import { render, staticRenderFns } from "./TripList.vue?vue&type=template&id=65807080&scoped=true&"
import script from "./TripList.vue?vue&type=script&lang=js&"
export * from "./TripList.vue?vue&type=script&lang=js&"
import style0 from "./TripList.vue?vue&type=style&index=0&id=65807080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65807080",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VCard,VPagination})
